module.exports = __webpack_public_path__ + "static/media/musiostore_home_tab.b37869f3.png";